<template>
  <b-card class="rounded-0 h-100" :class="getStyle.bgColor">
    <b-media>
      <slot slot="aside"></slot>
      <div class="text-right">
      <h3 :class="getStyle.title">{{ title }}</h3>
      <h6 :class="getStyle.subtitle">{{ subtitle }}</h6>
      <div>
        <i :class="getStyle.message">{{ message }}</i>
      </div>
      </div>
    </b-media>
  </b-card>
</template>

<script>
export default {
  props: {
    title: {
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    message: {
      type: String
    },
    variant: {
      type: String,
      default: function () {
        return 'light'
      }
    }
  },
  computed: {
    getStyle: function () {
      if (this.variant === 'dark') {
        return {
          bgColor: 'bg-dark',
          title: 'title-dark',
          subtitle: 'subtitle-light',
          message: 'text-danger'
        }
      } else if (this.variant === 'noHover') {
        return {
          bgColor: 'noHover',
          title: 'title-light',
          subtitle: 'subtitle-light'
        }
      } else {
        return {
          bgColor: 'white',
          title: 'title-light',
          subtitle: 'subtitle-light'
        }
      }
    }
  }
}
</script>

<style scoped>
  .title-dark {
    color: #fff;
    font-weight: 300;
  }

  .title-light {
    color: #455a64;
    font-weight: 300;
  }

  .subtitle-light {
    color: #99abb4;
  }

  .noHover {
    color: #455a64;
    font-weight: 300;
  }

  .bg-dark:hover{
    background-color: #455a64!important
  }
  
  .white:hover{
    background-color:  lightgray!important
  }

</style>



// WEBPACK FOOTER //
// src/components/common/Infobox.vue